import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { ApiRequestGet } from "../../../../data/network/services/ApiRequestGet";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import {
  numberWithCommas,
  RupeesToPaise,
} from "../../../../utility/commaSeperator";
import { RUPEE_SYMBOL } from "../../../../utility/Constants";
import { convertDateWithMonthName } from "../../../../utility/dateModifier";
import { PayInHeader } from "../../../../utility/TableHeaders";
import { CustomFilter } from "../../../components/CustomFilter";
import { CustomModal1 } from "../../../components/customModal/CustomModal";
import CustomTable from "../../../components/customTable/CustomTable";
import CustomViewModal from "../../../components/CustomViewModal";
import TopHeaderComponent from "../../../components/TopHeaderComponent";
import { SUCCESS } from "../../../resources/constantsManager";
import { saveAs } from "file-saver";

const Van = ({ filterOpened }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [openFilter, setOpenFilter] = useState(false);
  const [dateRange, setDateRange] = useState("");
  const [utr, setUtr] = useState("");
  const [van, setVan] = useState("");
  const [viewMoreModal, setShowViewMoreModal] = useState(false);
  const [data, setData] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [viewMoreData, setViewMoreData] = useState([]);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [offset, setOffset] = useState(0);
  const [isTableDataError, setIsTableDataError] = useState(false);

  const Filterdata = [
    {
      title: "Select Date Range",
      type: "dateRange",
      validator: "text",
      placeholder: "Select Date Range",
      key: "searchByDateRange",
      value: dateRange,
    },
    {
      title: "Search by UTR",
      type: "input",
      validator: "alphaNum",
      placeholder: "Search by UTR",
      key: "searchByDateRange",
      value: utr,
    },
    {
      title: "Search By Van",
      type: "input",
      validator: "alphaNum",
      placeholder: "Search by VAN No",
      key: "searchByDateRange",
      value: van,
    },
  ];

  const getVanTransactionHistory = (page, size, dateRange, utr, van) => {
    ApiRequestPost.vanTransactionHistory(page, size, dateRange, utr, van)
      .then((res) => {
        if (res.status === SUCCESS) {
          setData(res.data.content);
          setTotalElements(res.data.totalElements);
          setTotalPages(res.data.totalPages);
          setIsTableDataError(false);
        } else {
          setIsTableDataError(true);
        }
      })
      .catch((err) => {
        console.error(err);
        setIsTableDataError(true);
      });
  };

  const oncClickDownloaded = (page, size, dateRange, utr, van) => {
    ApiRequestGet.payInPayutDownload(page, size, dateRange, "payIn")
      .then((res) => {
        enqueueSnackbar("downloaded successfully", {
          variant: "success",
        });
        saveAs(res, "payin.csv");
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      });
  };

  const updateTransactionData = (id) => {
    data &&
      data?.map((val, i) => {
        if (val?.txnId === id) {
          setViewMoreData(val);
        }
      });
  };
  const getAllFilters = (data) => {
    setDateRange(data[0].value?.trim());
    setUtr(data[1].value?.trim());
    setVan(data[2].value?.trim());
    getVanTransactionHistory(
      0,
      10,
      data[0].value?.trim(),
      data[1].value?.trim(),
      data[2].value?.trim()
    );
    setOffset(0);
    setIsFilterApplied(!isFilterApplied);
  };

  useEffect(() => {
    getVanTransactionHistory(0, 10);
  }, []);

  return (
    <div style={{ height: "70%" }}>
      <TopHeaderComponent
        buttonRequired
        headerName="Pay In"
        onClickFilter={() => {
          setOpenFilter(!openFilter);
          filterOpened(!openFilter);
        }}
        onClickDownload={() => {
          oncClickDownloaded(0, totalElements, dateRange, utr, van);
        }}
        disableDownloadIcon={data?.length === 0}
        isRefreshRequired={true}
        onClickRefresh={() => {
          setOffset(0);
          getVanTransactionHistory(0, 10);
        }}
      />

      <div
        style={{
          width: "100%",
          borderRadius: "15px",
          display: "flex",
          alignItems: "center",
          opacity: openFilter ? 1 : 0,
          transition: "all 0.5s ease-in",
          marginTop: !openFilter ? "0px" : "10px",
        }}
      >
        <CustomFilter
          show={openFilter}
          data={Filterdata}
          search={(data) => {
            getAllFilters(data);
          }}
          onClickClear={() => {
            setDateRange("");
            setUtr("");
            setVan("");
            getVanTransactionHistory(0, 10, "", "", "");
          }}
          passActiveFilters={() => {}}
          showClearIcon={true}
        />
      </div>

      <div
        style={{
          marginTop: "20px",
        }}
      >
        <CustomTable
          headers={PayInHeader}
          totalElements={totalElements}
          data={data}
          viewMore={(data) => {
            setShowViewMoreModal(true);
            setViewMoreData(data);
            console.log("cc", data);
          }}
          totalPages={totalPages}
          handlePaginate={(page) => {
            setOffset(page);
            getVanTransactionHistory(page, 10, dateRange, utr, van);
          }}
          offset={offset}
          isFilterApplied={openFilter}
          isTableDataError={isTableDataError}
        />
      </div>
      {viewMoreModal && (
        <CustomModal1
          open={viewMoreModal}
          onClose={() => setShowViewMoreModal(false)}
          viewMoreStyle={{
            justifyContent: "flex-end",
          }}
        >
          {" "}
          <CustomViewModal
            data={{
              "Date & Time": convertDateWithMonthName(
                new Date(viewMoreData?.createdDate)
              ),
              "UTR:": viewMoreData?.txnId,
              "VAN:": viewMoreData?.beneAccountNo,
              "Transaction Type:": viewMoreData?.debit ? "Debit" : "Credit",
              "Amount:":
                RUPEE_SYMBOL +
                "" +
                numberWithCommas(RupeesToPaise(viewMoreData?.transferAmt)),
              "Status:": viewMoreData?.status,
              "Fees:":
                RUPEE_SYMBOL +
                "" +
                numberWithCommas(RupeesToPaise(viewMoreData?.commission)),
              "Tax:":
                RUPEE_SYMBOL +
                "" +
                numberWithCommas(RupeesToPaise(viewMoreData?.tax)),
              "beneficiary_account_no:": viewMoreData?.beneAccountNo,
              "beneficiary_account_ifsc:": viewMoreData?.beneAccountIfsc,
              "beneficiary_full_name:": viewMoreData?.beneFullName,
              "transfer_type:": viewMoreData?.transferType,
              "transfer_unique_no:": viewMoreData?.transferUniqueNo,
              "transfer_timestamp:": convertDateWithMonthName(
                new Date(viewMoreData?.transferTimestamp)
              ),
              "transfer_ccy:": viewMoreData?.transferCcy,
              "rmtr_account_no:": viewMoreData?.rmtrAccountNo,
              "rmtr_account_ifsc:": viewMoreData?.rmtrAccountIfsc,
              "rmtr_account_type:": viewMoreData?.rmtrAccountType,
              "description:": viewMoreData?.description,
            }}
            closeModal={() => setShowViewMoreModal(false)}
            // onClickRefresh={(val) => {
            //   getVanTransactionHistory(0, 10);
            //   updateTransactionData(val);
            // }}
          />
        </CustomModal1>
      )}
    </div>
  );
};

export default Van;
